import { cloneObject } from '../../../utilities';

const getLabelsQuill = (_labelField, _xAxisField, _yAxisField, _fields) => {
  const labelsQuill = {
    ops: [
      {
        insert: {
          inlineValue: {
            fieldName: _labelField,
            title: _fields[_labelField].title,
            format: cloneObject(_fields[_labelField].format),
          },
        },
      },
      { insert: ': ' },
      {
        insert: {
          inlineValue: {
            fieldName: _yAxisField,
            title: _fields[_yAxisField].title,
            format: cloneObject(_fields[_yAxisField].format),
          },
        },
      },
      { insert: '\n' },
    ],
  };

  return labelsQuill;
};

export default getLabelsQuill;
